import {iFrameState} from "../../services/IFrameState.js";
import {PANEL_TYPE} from "../../../blink-sdk/Constants.js";
import {DonationAuthPage} from "../auth/DonationAuthPage.jsx";
import {SubscribeAuthPage} from "../auth/SubscribeAuthPage.jsx";
import {AuthPanelPage} from "../auth/AuthPanelPage.jsx";
import {Route} from "../../../stem-core/ui/Router.jsx";
import {
    ADDRESS_PANEL_URL,
    CTA_URL,
    FUNCTIONALITY_NOT_ENABLED_URL,
    INLINE_DONATION_URLS,
    INLINE_EDIT_DONATION_URLS,
    INLINE_EDIT_SUBSCRIPTION_URLS,
    INLINE_GIFT_SUBSCRIPTION_URLS,
    INLINE_NEWSLETTER_URLS,
    INLINE_SHOP_URLS,
    INLINE_SUBSCRIPTION_URLS,
    INLINE_USER_DASHBOARD_URLS, OAUTH_CONNECT_URL,
    PAYMENT_DETAILS_PANEL_URL,
    PAYMENT_FAILED_PANEL_URL,
    SUBSCRIPTION_PLAN_PANEL_URL
} from "../PanelConstants.js";
import {FunctionalityNotEnabledPanel} from "./panels/FunctionalityNotEnabledPanel.jsx";
import {LOGIN_URL, LOGIN_WITH_EMAIL_CODE_URL} from "../../Constants.js";
import {EmailCodeConfirmationPanel} from "../auth/EmailCodeConfirmationPanel.jsx";
import {CustomContentPanel} from "./panels/CustomContentPanel.jsx";
import {PanelCollapsed} from "./panels/PanelCollapsed.jsx";
import {NewsletterSubscribePanel} from "./panels/newsletter/NewsletterSubscribePanel.jsx";
import {NewsletterSubscribeSuccessPanel} from "./panels/newsletter/NewsletterSubscribeSuccessPanel.jsx";
import {DonatePanel} from "./panels/donation/DonatePanel.jsx";
import {PaymentAndDonationPanel} from "./panels/donation/PaymentAndDonationPanel.jsx";
import {DonationSuccessPanel} from "./panels/donation/DonationSuccessPanel.jsx";
import {EditDonationPanel} from "./panels/donation/edit-donation/EditDonationPanel.jsx";
import {EditDonationSuccessPanel} from "./panels/donation/edit-donation/EditDonationSuccessPanel.jsx";
import {CancelDonationPanel} from "./panels/donation/edit-donation/CancelDonationPanel.jsx";
import {DonationCanceledPanel} from "./panels/donation/edit-donation/DonationCanceledPanel.jsx";
import {SubscribeReviewOrderPanel} from "./panels/subscribe/SubscribeReviewOrderPanel.jsx";
import {SubscribeSuccessPanel} from "./panels/subscribe/SubscribeSuccessPanel.jsx";
import {GiftSubscriptionDetailsPanel} from "./panels/subscribe/gift-subscriptions/GiftSubscriptionDetailsPanel.jsx";
import {GiftSubscriptionSuccessPanel} from "./panels/subscribe/gift-subscriptions/GiftSubscriptionSuccessPanel.jsx";
import {ManageSubscriptionPanel} from "./user-dashboard/tabs/UserDashboardSubscriptionTab.jsx";
import {EditSubscriptionCancelPanel} from "./panels/subscribe/edit-subscription/EditSubscriptionCancelPanel.jsx";
import {EditSubscriptionCancelSuccessPanel} from "./panels/subscribe/edit-subscription/EditSubscriptionCancelSuccessPanel.jsx";
import {EditSubscriptionConfirmPanel} from "./panels/subscribe/edit-subscription/EditSubscriptionConfirmPanel.jsx";
import {EditSubscriptionSuccessPanel} from "./panels/subscribe/edit-subscription/EditSubscriptionSuccessPanel.jsx";
import {UserDashboard} from "./user-dashboard/UserDashboard.jsx";
import {UserDashboardRemoveCardPanel} from "./user-dashboard/prompt-panels/UserDashboardRemoveCardPanel.jsx";
import {UserDashboardRemoveAddressPanel} from "./user-dashboard/prompt-panels/UserDashboardRemoveAddressPanel.jsx";
import {UserDashboardChangeEmailCodeConfirmPanel} from "./user-dashboard/prompt-panels/UserDashboardChangeEmailCodeConfirmPanel.jsx";
import {ShopPanel} from "./shop/ShopPanel.jsx";
import {ShopReviewOrderPanel} from "./shop/ShopReviewOrderPanel.jsx";
import {ShopOrderSuccessPanel} from "./shop/ShopOrderSuccessPanel.jsx";
import {SubscriptionPlanPanel} from "./panels/subscribe/SubscriptionPlanPanel.jsx";
import {PaymentMethodPanel} from "./panels/payment-method/PaymentMethodPanel.jsx";
import {PaymentFailedPanel} from "./panels/payment-method/PaymentFailedPanel.jsx";
import {AddressPanel} from "./panels/address/AddressPanel.jsx";
import {OAuthConnectPanel} from "./OAuthConnectPanel.jsx";


export function BuildPanelRoutes() {
    const getAuthPage = (...args: ConstructorParameters<typeof AuthPanelPage>) => {
        if (iFrameState.isInlineDonationFlow()) {
            return new DonationAuthPage(...args);
        }
        if (iFrameState.isInlineSubscriptionFlow()) {
            return new SubscribeAuthPage(...args);
        }

        return new AuthPanelPage(...args);
    };

    const buildRoute = (route: string, pageClass: ConstructorParameters<typeof Route>[1], options = {doNotCache: true}) => new Route([route], pageClass, [], options);

    return [
        buildRoute(FUNCTIONALITY_NOT_ENABLED_URL, FunctionalityNotEnabledPanel),

        buildRoute(LOGIN_URL, getAuthPage),
        buildRoute(LOGIN_WITH_EMAIL_CODE_URL, EmailCodeConfirmationPanel),

        buildRoute(CTA_URL, CustomContentPanel), // TODO @branch WTF is this shit?

        buildRoute(PANEL_TYPE.empty, PanelCollapsed),

        buildRoute(INLINE_NEWSLETTER_URLS.subscribe, NewsletterSubscribePanel),
        buildRoute(INLINE_NEWSLETTER_URLS.success, NewsletterSubscribeSuccessPanel),

        buildRoute(INLINE_DONATION_URLS.donate, DonatePanel),
        buildRoute(INLINE_DONATION_URLS.paymentAndDonate, PaymentAndDonationPanel),
        buildRoute(INLINE_DONATION_URLS.thankYou, DonationSuccessPanel),

        buildRoute(INLINE_EDIT_DONATION_URLS.donate, EditDonationPanel),
        buildRoute(INLINE_EDIT_DONATION_URLS.thankYou, EditDonationSuccessPanel),
        buildRoute(INLINE_EDIT_DONATION_URLS.cancel, CancelDonationPanel),
        buildRoute(INLINE_EDIT_DONATION_URLS.cancelSuccess, DonationCanceledPanel),

        buildRoute(INLINE_SUBSCRIPTION_URLS.subscriptionCheckout, SubscribeReviewOrderPanel),
        buildRoute(INLINE_SUBSCRIPTION_URLS.subscribeThankYou, SubscribeSuccessPanel),

        buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.giftDetails, GiftSubscriptionDetailsPanel),
        buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.success, GiftSubscriptionSuccessPanel),

        buildRoute(INLINE_SUBSCRIPTION_URLS.subscriptionManageInline, ManageSubscriptionPanel),

        buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.cancel, EditSubscriptionCancelPanel),
        buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.cancelSuccess, EditSubscriptionCancelSuccessPanel),
        buildRoute(INLINE_USER_DASHBOARD_URLS.subscriptionChangeConfirm, EditSubscriptionConfirmPanel),
        buildRoute(INLINE_USER_DASHBOARD_URLS.subscriptionChangeSuccess, EditSubscriptionSuccessPanel),

        buildRoute(INLINE_USER_DASHBOARD_URLS.home, UserDashboard),
        buildRoute(INLINE_USER_DASHBOARD_URLS.removeCard, UserDashboardRemoveCardPanel),
        buildRoute(INLINE_USER_DASHBOARD_URLS.removeAddress, UserDashboardRemoveAddressPanel),
        buildRoute(INLINE_USER_DASHBOARD_URLS.changeEmailConfirmationCode, UserDashboardChangeEmailCodeConfirmPanel),

        buildRoute(INLINE_SHOP_URLS.products, ShopPanel),
        buildRoute(INLINE_SHOP_URLS.reviewOrder, ShopReviewOrderPanel),
        buildRoute(INLINE_SHOP_URLS.orderSuccess, ShopOrderSuccessPanel),

        buildRoute(SUBSCRIPTION_PLAN_PANEL_URL, SubscriptionPlanPanel),
        buildRoute(PAYMENT_DETAILS_PANEL_URL, PaymentMethodPanel),
        buildRoute(PAYMENT_FAILED_PANEL_URL, PaymentFailedPanel),
        buildRoute(ADDRESS_PANEL_URL, AddressPanel),
        buildRoute(OAUTH_CONNECT_URL, OAuthConnectPanel),
    ];
}
